import { renderDecimal } from '@synqo/frontend-component-library';
import classes from './StockQuantity.module.css';

interface IProps {
    value: number;
    unit?: string;
    bold?: boolean;
}

/** A stock in tons with 3 decimals, in red when it is negative. */
// @ai-generated 2026-10-23T14:10:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function StockQuantity({ value, unit, bold }: IProps) {
    return (
        <span className={classes.stock} data-negative={value < 0 || undefined} data-bold={bold}>
            {renderDecimal(value, 3)}
            {unit && ` ${unit}`}
        </span>
    );
}
